import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import Fade from 'react-reveal/Fade'
import AniLink from 'gatsby-plugin-transition-link/AniLink'
import { StaticImage, GatsbyImage, getImage } from 'gatsby-plugin-image'
import { graphql } from "gatsby"

import ResponsiveContainer from 'components/utils/ResponsiveContainer'
import Layout from 'components/Layout'
import { Header3, Header4, Header6, HeaderUnderline } from 'components/UI/Header'
import SpeakersBlock from 'components/Pages/Home/SpeakersBlock'
import RoadshowBlock from 'components/Pages/Home/RoadshowBlock'

import OrFlower from 'images/or-flower-red-01.inline.svg'

const Home = ({data}) => {

  const diffdate = new Date();
  const arrSortDateDiff = [...data.strapiHomeRoadshowEvents.Events.filter( item => item.clickable )]
  arrSortDateDiff.sort((a, b) => {
    var distancea = Math.abs(diffdate - new Date(a.date));
    var distanceb = Math.abs(diffdate - new Date(b.date));
    return distancea - distanceb; // sort a before b when the distance is smaller
  })

  const [currentRoadshowId,setCurrentRoadshowId] = useState(arrSortDateDiff[0]['id'])
  const [currentRoadshow,setCurrentRoadshow] = useState([])

  useEffect(() => {
    setCurrentRoadshow([...data.strapiHomeRoadshowEvents.Events.filter(item => item.id == currentRoadshowId)])
  }, [currentRoadshowId,setCurrentRoadshow])

  console.log(currentRoadshow)

  const floatingHeader = true

  return (
    <>
      <Layout floatingHeader={ floatingHeader }>
        <section className="bg-primary text-white relative z-10 md:h-screen md:overflow-visible ">
            <ResponsiveContainer className="pt-20 relative md:h-full">
                <div className="h-96 flex flex-col items-start justify-center relative z-10 md:h-full lg:w-6/12 ">
                    <Fade>
                    <h1 className="text-4xl font-bold uppercase mb-2 md:text-7xl">Integrated platform-based event,</h1>
                    <h1 className="text-black text-2xl font-bold mb-12">Which provides open access to Indonesia's tech startup ecosystem.</h1>
                    <AniLink cover bg="#000000" to="/contact" className='px-4 py-3 rounded-lg font-bold text-white bg-black'>Register</AniLink>
                    </Fade>
                </div>
                <StyledOrFlower className="absolute top-0 left-0 w-auto h-full md:-right-40 md:left-auto" />                
            </ResponsiveContainer>
        </section>
        <section>
            <ResponsiveContainer className="py-20 lg:py-32">
              
              <Fade>
                  <HeaderUnderline className="mb-12" title={<>Roadshow<br />Event</>} underlineClass="text-primary w-1/2 h-auto"  />
              </Fade>
              <Fade spy={currentRoadshowId}>
                {currentRoadshow.length > 0 && 
                  <>
                    {currentRoadshow.map( item => {
                      const eventDate = new Date(item.date)
                      return (
                        <>
                          <Header3 className="text-center md:w-10/12 md:mx-auto lg:w-8/12">{ item.title }<br /><span className="text-primary">{ eventDate.getDate()} { eventDate.toLocaleString('en-en', { month: 'long' }) } { eventDate.getFullYear() }</span></Header3>
                          <Header6 className="text-center mb-16">Keynote Speakers</Header6>
                          <div className="grid grod-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-5">
                            {item.Speakers.map( item => {
                              const image = getImage(item.photo.localFile)
                              return (
                                <SpeakersBlock name={item.name} position={item.title} photo={<GatsbyImage image={image} alt="" />} />
                              )
                            })}
                        </div>
                        </>
                      )
                    })}
                  </>
                }
              </Fade>
              <div className="gap-4 grid grid-cols-1 md:grid-cols-3">
                {data.strapiHomeRoadshowEvents.Events.map( item => {
                  const eventDate = new Date(item.date)
                  return (
                    <RoadshowBlock title={item.menuTitle} clickable={item.clickable} date={`${ eventDate.getDate()} ${ eventDate.toLocaleString('en-en', { month: 'long' }) } ${ eventDate.getFullYear() }`} active={ item.id === currentRoadshowId } onClick={() => { if(item.clickable) { setCurrentRoadshowId(item.id) } else { return false } }} />
                  )
                })}
              </div>
            </ResponsiveContainer>
        </section>
      </Layout>
    </>
  )
}

const StyledOrFlower = styled(OrFlower)`
  @media (min-width: 768px) {
    height: 110%;
  }
`

export const query = graphql`
  {
    strapiHomeRoadshowEvents {
      Events {
        id
        title
        menuTitle
        date
        clickable
        Speakers {
          id
          name
          title
          photo {
            localFile {
              childImageSharp {
                gatsbyImageData(
                  aspectRatio: 1
                  width: 400
                  formats: WEBP
                  placeholder: BLURRED
                  quality: 90
                )
              }
            }
          }
        }
      }
    }
  }
`

export default Home
